<div class="relative w-full">
  <label class="cursor-text">
    <input
      [type]="type"
      [disabled]="isDisabled"
      [value]="value"
      (input)="handleInput($event)"
      (blur)="onTouched()"
      placeholder=" "
      class="peer w-full border border-cinza rounded-md px-3 pt-5 pb-2 text-sm placeholder-transparent focus:outline-none focus:border-primary disabled:bg-gray-100"
    />
    <div
      class="absolute left-3 top-2 text-cinza text-sm transition-all duration-200 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-4 peer-focus:text-sm peer-focus:text-primary"
    >
      {{ placeholder }}
    </div>
  </label>
</div>
